import { Box, BoxProps } from '@mui/material';
import React from 'react';

export default function Row(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={{ display: 'flex', alignItems: 'center', ...props.sx }}
    ></Box>
  );
}
